angular.module('rjmNg.directives').directive "dataWarehouseConnectionList", [
  () ->
    restrict: "E"
    templateUrl: "directive.dataWarehouseConnectionList.html"
    replace: true
    scope:
      active: '='
      loading: "="
    bindToController: true
    controllerAs: "view"
    controller: [
      "$rootScope"
      "$routeParams"
      "remoteDBConnectionService"
      "dataWarehouseTablePath"
      "persistentViewsService"
      "$q"
      "app"
      "notification"
      (
        $rootScope
        $routeParams
        remoteDBConnectionService
        dataWarehouseTablePath
        persistentViewsService
        $q
        app
        notification
      ) ->
        view = @

        view.supportEmail = app.getSupportEmail()
        view.databasesBlocked = true
        view.showAllTables = false
        view.search = {name : ''}

        isOpenNewWindowKey = (clickEvent) ->
          clickEvent.altKey or clickEvent.metaKey or clickEvent.shiftKey

        view.selectTable = (clickEvent, connectionId, databaseName, rsTable) ->
          # Allow browser to handle clicks that would open new tabs and
          # angular to deal with the rest
          if clickEvent
            if isOpenNewWindowKey(clickEvent)
              clickEvent.stopPropagation()
              return false
            else
              clickEvent.preventDefault()

          $rootScope.$broadcast('dataWarehouse.rsTableActivated',
            connectionId, databaseName, rsTable, view.totalTrackedRows, view.viewTableIds)

        _handleRouteParamsForTable = () ->
          targetTable = null
          if $routeParams.tableId?
            targetTable = view.localTables[+$routeParams.tableId]
          if targetTable?
            view.selectTable undefined, targetTable.connectionId, targetTable.databaseName, targetTable
          else if view.viewTableIds[+$routeParams.tableId]
            targetTable = view.viewTableIds[+$routeParams.tableId]
            targetTable.isView = true
            view.selectTable undefined, targetTable.connectionId, targetTable.databaseName, targetTable
          else
            dataWarehouseTablePath.updateTablePath()

        _isValidConnection = (conOb) ->
          return conOb?.rsConnections? and Object.keys(conOb.rsConnections).length > 0

        @$onInit = ->
          $q.all([remoteDBConnectionService.fetch(), persistentViewsService.getViewSchema()])
          .then( ([result, persistentViewsList]) ->
            if _isValidConnection(result)
              view.connectionResult = result

              persistentViewsService.addToDWMList persistentViewsList, view.connectionResult.rsConnections

              view.databasesBlocked = false
              if _.isEmpty(view.connectionResult.rsConnections)
                view.noConnectionsFound = true
              view.totalTrackedRows = view.connectionResult.totalTrackedRows

              view.localTables = remoteDBConnectionService.localTables()
              view.viewTableIds = _.indexBy(persistentViewsList, 'id')
              _handleRouteParamsForTable()
              view.loading = false

          , (error) ->
            view.databasesBlocked = true
            notification.error(
              "",
              "There seems to be an issue with our servers. Please wait a few minutes and try again. If the problem persists please contact <a class='rj-button--plain' ng-href='mailto:#{view.supportEmail}'></span> #{view.supportEmail}</a>",
              "data-warehouse-notifications",
              { dismissable: false, bindHtml: true }
            )
            view.loading = false
          )

        $rootScope.$on 'droppedTable', () ->
          view.localTables = remoteDBConnectionService.localTables()

        view
      ]

]
